import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bid-modal-users',
  templateUrl: './modal-users.component.html',
  styleUrls: ['./modal-users.component.scss'],
})
export class ModalUsersComponent {
  @Input() opened: boolean = false;
  @Input() headerText: string = '';
  @Input() contentText: string = '';
  @Input() submitBtnText: string = '';
  @Input() user: any;
  @Input() col: number = -1;

  @Output() closed = new EventEmitter<object>();

  cancel() {
    const closeEventObject = {
      submit: false,
    };
    this.closed.emit(closeEventObject);
  }

  submit() {
    const closeEventObject = {
      submit: true,
      user: this.user,
    };
    this.closed.emit(closeEventObject);
  }
}
